module.exports = __webpack_public_path__ + "static/media/thumbnail.4f0a7ce8.jpg";